import { render, staticRenderFns } from "./ProjeDuzenle.vue?vue&type=template&id=5318037c&scoped=true&"
import script from "./ProjeDuzenle.vue?vue&type=script&lang=js&"
export * from "./ProjeDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./ProjeDuzenle.vue?vue&type=style&index=0&id=5318037c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318037c",
  null
  
)

export default component.exports